module.exports = __webpack_public_path__ + "static/media/receta-05.0ea31ed5.png";